import {
  AttributeType,
  DataType,
  FilterType,
  IFilterTemplate,
  IQuickFilterTemplate,
  SelectionFilterCriteria,
  selectionCriteriaValues,
} from "packable-components";

export const EXCLUDE_DELETED_AND_EXPIRED_FILTER_UUID =
  "3e3f0f76-384e-4916-a803-14c94c8c9c46";

export const filterTemplateList: Array<IFilterTemplate> = [
  {
    filterType: FilterType.range,
    dataType: DataType.number,
    attributeType: AttributeType.simple,
    objectName: "item",
    objectTitle: "Item",
    fieldName: "value",
    fieldTitle: "Value",
    prefix: "$",
    onlyPositive: true,
  },
  {
    filterType: FilterType.range,
    dataType: DataType.number,
    attributeType: AttributeType.simple,
    objectName: "item",
    objectTitle: "Item",
    fieldName: "weight",
    fieldTitle: "Weight",
    suffix: "lb",
    onlyPositive: true,
  },
  {
    filterType: FilterType.selection,
    attributeType: AttributeType.simple,
    dataType: DataType.string,
    objectName: "space",
    objectTitle: "Item",
    fieldName: "name",
    fieldTitle: "Space",
    lookupURL: "/space/lookup/",
  },
  {
    filterType: FilterType.selection,
    attributeType: AttributeType.simple,
    dataType: DataType.string,
    objectName: "category",
    objectTitle: "Item",
    fieldName: "name",
    fieldTitle: "Category",
    lookupURL: "/category/lookup/",
  },
  {
    filterType: FilterType.selection,
    attributeType: AttributeType.simple,
    dataType: DataType.string,
    objectName: "tag",
    objectTitle: "Item",
    fieldName: "name",
    fieldTitle: "Tag",
    lookupURL: "/tag/lookup/",
  },
  {
    filterType: FilterType.selection,
    attributeType: AttributeType.simple,
    dataType: DataType.string,
    objectName: "location",
    objectTitle: "Item",
    fieldName: "locationType",
    fieldTitle: "Location",
    lookupURL: "/item/location-type-lookup/",
  },
  {
    filterType: FilterType.selection,
    attributeType: AttributeType.simple,
    dataType: DataType.string,
    objectName: "item",
    objectTitle: "Item",
    fieldName: "stage",
    fieldTitle: "Stage",
    lookupURL: "/item/stage-lookup/",
  },
  {
    filterType: FilterType.selection,
    attributeType: AttributeType.simple,
    dataType: DataType.string,
    objectName: "packable_order",
    objectTitle: "Order",
    fieldName: "status",
    fieldTitle: "Status",
    lookupURL: "/order/status-lookup/",
  },
];

export const quickFilterTemplateList: Array<IQuickFilterTemplate> = [
  {
    id: EXCLUDE_DELETED_AND_EXPIRED_FILTER_UUID,
    filterTitle: "Active Only",
    chipStyles: {
      PackableFilterQuickFilterChip: {
        color: "#ffffff",
        background: "#449966",
      },
    },
    filter: {
      id: EXCLUDE_DELETED_AND_EXPIRED_FILTER_UUID,
      filterType: FilterType.selection,
      dataType: DataType.string,
      attributeType: AttributeType.simple,
      objectName: "packable_order",
      objectTitle: "Order",
      fieldName: "status",
      fieldTitle: "Status",
      lookupURL: "/order/status-lookup/",
      criteria: SelectionFilterCriteria.notIn,
      criteriaDescription:
        selectionCriteriaValues[
          Object.values(SelectionFilterCriteria).indexOf(
            SelectionFilterCriteria.notIn
          )
        ],
      values: [
        { key: "DELETED", value: "Deleted" },
        { key: "EXPIRED", value: "Expired" },
        { key: "COMPLETED", value: "Compelted" },
      ],
    },
  },
];
